<template>

<app-item route="Access" :id="item.id" id-name="access">

	<app-item-title :text="item.user.name" :subtitle="levels[item.level]" />

</app-item>

</template>

<script>

export default {

	props: ['item'],

	data: function() {

		return {
			levels: {
				1: 'Owner',
				2: 'Admin',
				3: 'Editor'
			}

		}

	}

}

</script>

<style scoped>

</style>
